import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { NAV_PRODUCTS as PRODUCT_LIST } from "../pages/products";

const COLS = [
  { title: "Qora QR", links: [["QR dinamici e statici", "/qora-qr"], ["Statistiche di scansione", "/qora-qr"], ["Prova un QR", "/#in-azione"]] },
  { title: "Qora Link", links: [["Pagine pubbliche", "/qora-link"], ["Promozioni e pop-up", "/qora-link"], ["Apri una demo", "/#in-azione"]] },
  { title: "Qora Menu", links: [["Menù digitale", "/qora-menu"], ["Allergeni e PDF", "/qora-menu"], ["Guarda un menù", "/#in-azione"]] },
  { title: "Qora", links: [["Qora MiniSite", "/qora-minisite"], ["Qora Complete", "/qora-complete"], ["Prezzi", "/prezzi"], ["Qora Menu Check (gratis)", "/menu-check"], ["Funzionalità", "/funzionalita"], ["Guide", "/guide"], ["FAQ", "/faq"], ["Chi è Qora", "/chi-e-qora"], ["Supporto", "mailto:support@myqora.it"], ["Privacy", "/privacy"], ["Termini", "/termini"], ["Cookie", "/cookie"], ["Pagamenti", "/informativa-pagamenti"]] },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-[#0c2d34] text-white" data-testid="footer">
      <div className="container-xl py-14">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/qora-symbol.png" alt="Qora" className="h-9 w-9 rounded-lg" />
              <span className="font-display text-xl font-extrabold text-white">Qora</span>
            </Link>
            <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">Una piattaforma: Qora MiniSite, Qora Menu, Qora QR e Qora Link gratis. Crea, collega e misura.</p>
            <div className="flex flex-wrap gap-2 mt-5">
              {PRODUCT_LIST.map((p) => <Link key={p.key} to={p.path} className="inline-flex items-center gap-1.5 rounded-full bg-white/10 hover:bg-white/15 px-3 py-1.5 text-xs font-semibold"><p.Icon className="h-3.5 w-3.5 text-[#8fd7c4]" /> {p.name}</Link>)}
            </div>
            <div className="flex gap-3 mt-5">
              {[Instagram, Linkedin].map((Icon, i) => <a key={i} href="#" className="h-9 w-9 grid place-items-center rounded-lg bg-white/8 hover:bg-white/15 transition-colors"><Icon className="h-4 w-4" /></a>)}
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="font-semibold text-sm mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map(([l, to]) => <li key={l}>{to.startsWith("/#") || to.startsWith("mailto:") ? <a href={to} className="text-sm text-white/55 hover:text-white transition-colors">{l}</a> : <Link to={to} className="text-sm text-white/55 hover:text-white transition-colors">{l}</Link>}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/50">© {new Date().getFullYear()} Qora · servizio gestito da Labix. Tutti i diritti riservati.</p>
          <p className="text-xs text-white/40">Fatto con cura in Italia</p>
        </div>
      </div>
    </footer>
  );
}
